import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/checkServiceReviews', request)
}

export {get}
